<template>
    <div class="body">
		<div style="padding-top:17vh;display:flex;justify-content: center;align-items: center;flex-wrap: wrap;">
			<span style="width:100vh;margin:0;text-align: center;font-size: 51px;font-weight: 800;color: #30bfff;text-shadow: #fff 0px 0px 2px,   #fff 0px 0px 2px,   #fff 0px 0px 2px, #fff 0px 0px 2px,   #fff 0px 0px 2px,   #fff 0px 0px 2px;font-family:'Gentium Basic', serif;">2025</span>
			<span style="width:100vh;margin:0;text-align: center;font-weight: bolder; font-size: 27px;color: #30bfff;text-shadow: #fff 0px 0px 5px,   #fff 0px 0px 4px,   #fff 0px 0px 4px, #fff 0px 0px 5px,   #fff 0px 0px 5px,   #fff 0px 0px 5px;font-family: 'Eczar', cursive,sans-serif;">富学宝典</span>
			<span style="margin:7px;background:cadetblue;padding: 4px 17px;border-radius: 11px;background: linear-gradient(180deg,#a0d9f3,#e6ecb9);font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman',cursive, serif; color: #2c7fa2">四月学习报告</span>
			<span style="width:100vh;margin:0;text-align: center;font-size: 27px;color: #30bfff;font-family: 'Eczar', cursive,sans-serif;">坚持学习的人永葆青春</span>
		</div>
        <div v-show="false">
			<div class="form" v-show="playtimeShow">
				<input class="input" placeholder="请输入工号" v-model="thisJobNo" type="text">
				<span class="input-border"></span>
			</div>
			<button v-show="playtimeShow" :style="'margin-top:'+ windowWidth*0.16 +'px;'" @click="sumbitJobNo"> let's go<span></span></button>
		</div>
	</div>
</template>
  
<script>
import jieliufa from '@/utils/jieliufa'
export default {
	data() {
		return {
			thisJobNo: '',
			buttonShow: true,
			windowWidth: window.innerHeight,
			playtimeShow: true
		}
	},
	methods: {
		sumbit: jieliufa.throttle(function() {
			/*节流：
			*在规定的时间间隔范围内不会重发触发回调，只有大于时间间隔才会触发回调
			*也就是说，把频发触发变成少量触发
			*/
			this.sumbitJobNo()
		},1000),
		sumbitJobNo() {
			if (!this.thisJobNo) {
				this.$message({
					message: "工号不能为空",
					type: "warning",
					center: true
				})
				return
			}
			this.$emit('inputJobNo',this.thisJobNo)
		},
	}
}
</script>
  
<style scoped>
.body {
    /* background:linear-gradient(-170deg,#ffa6a2 , #fecc97); */
    background:url("../../assets/25April/bg.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
}

.form {
    --width-of-input: 270px;
    --border-height: 1px;
    --border-before-color: #fff;
    /* --border-after-color: linear-gradient(40deg,#fecc94,#fecc94); */
    position: relative;
    width: var(--width-of-input);
    margin: 0 auto;
    top: 77px;
}

.input {
    color: #5b7b2d;
    font-size: 1.1rem;
    background-color: transparent;
    width: 100%;
    box-sizing: border-box;
    padding-inline: 0.5em;
    padding-block: 0.7em;
    border: none;
    border-bottom: var(--border-height) solid var(--border-before-color);
    font-family: monospace;
}

.input-border {
    position: absolute;
    background: var(--border-after-color);
    width: 0%;
    height: 2px;
    bottom: 0;
    left: 0;
    transition: 0.3s;
}

input:focus {
    outline: none;
}  
  
button {
    width: 7em;
    position: absolute;
    height: 2.5em;
    border: 3px ridge #c7f0c8;
    outline: none;
    background-color: transparent;
    color: #78a23d;
    transition: 1s;
    border-radius: 0.3em;
    font-size: 16px;
    font-weight: bold;
    left: 50%;
    transform: translateX(-50%);
    animation: light 3s infinite;
}
  
@keyframes light {
    0%{
      	box-shadow: inset 0px 0px 7px #c4d5ac;
    }
    50%{
      	/* letter-spacing: 0.25em; */
      	box-shadow: inset 0px 0px 47px #c8f3c1;
    }
    100%{
		/* letter-spacing: 0.25em; */
		box-shadow: inset 0px 0px 7px #a4eba0;
    }
}
  
button::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
    transform-origin: center;
}
  
button::before {
    content: "";
    transform-origin: center;
    position: absolute;
    top: 80%;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
} 
</style>